import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { ADMIN_ENV, headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { patch } = request;
const { Authorization, Bearer } = AUTHORIZATION;

// eslint-disable-next-line arrow-parens
export const editClaimVisibilityById = async (_payload: any, params: string) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `auth/claim-visibility/${params}`;
		const token = localStorage.getItem("@jwt");
		const response = await patch(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.patch.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else {
			throw error;
		}
	}
};
